'use client';

import { useFormikContext } from 'formik';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

type Props = {
  message?: string;
};

const FormSavingBar = ({ message = 'Saving...' }: Props) => {
  const { isSubmitting } = useFormikContext();

  if (!isSubmitting) {
    return null;
  }

  return (
    <Box sx={{ mt: 2, mb: 2, width: '100%' }}>
      <LinearProgress />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default FormSavingBar;
